import {ClipLoader} from "react-spinners";

export default function Loader() {
    return (
        <div className="flex justify-center items-center h-screen">
            <ClipLoader size={80} color="#17A34A"/>
        </div>
    );
}
